import { getStore as getSharedFavoriteStore } from 'owa-favorites';
import { getPersonaNodeIdFromExtendedProperty } from 'owa-mail-persona-search-folder-services';
import folderStore, { Folder } from 'owa-folders';
import { action } from 'satcheljs/lib/legacy';

export default action('setupFavoritePersona')(function setupFavoritePersona(
    personaSearchFolder: Folder
) {
    const favoriteNodeId = getPersonaNodeIdFromExtendedProperty(personaSearchFolder);

    // The persona search folder includes a guid in the displayName which surfaces
    // in certain dialogs, for example "Delete All". By changing the display name here,
    // the folder doesn't need any special treatment.

    const favoritePersona = getSharedFavoriteStore().favoritesPersonaNodes.get(favoriteNodeId);

    if (favoritePersona) {
        const displayName = favoritePersona.displayName;
        const searchFolder = { ...personaSearchFolder, DisplayName: displayName };
        folderStore.folderTable.set(personaSearchFolder.FolderId.Id, searchFolder);

        const newSearchFolderId = searchFolder.FolderId.Id;

        if (favoritePersona.searchFolderId !== newSearchFolderId) {
            favoritePersona.searchFolderId = newSearchFolderId;
        }
    }
});
